import { SafeArea } from '@capacitor-community/safe-area';
import { isPlatform } from '@ionic/react';
import { useEffect } from 'react';

/**
 * TODO: Remove this hook when we upgrade to Ionic 7.0.0 or later.
 *
 * This hook is used to enable the safe area plugin on Android.
 *
 * This is necessary since the SafeArea plugin is not supported by Ionic natively
 * for versions of Ionic that are less than 7.0.0.
 *
 * @see https://github.com/capacitor-community/safe-area
 * @see https://github.com/ionic-team/capacitor/pull/7871 (Android Edge to Edge support)
 */
const useSafeArea = (): void => {
  useEffect(() => {
    if (isPlatform('capacitor') && isPlatform('android')) {
      SafeArea.enable({
        config: {}, // we don't need to customize colors
      });
    }
  }, []);
};

export { useSafeArea };
